
module dg.actions {

    export interface ICommandStateResolve extends angular.ui.IViewStateResolve {
        link?(...args: any[]): dg.restfulApi.Link | ng.IPromise<dg.restfulApi.Link>;
        command(...args: any[]): dg.domain.actions.IDomainAction | ng.IPromise<dg.domain.actions.IDomainAction>;
        propTemplateUrl?: () => string;
    }

    export class CommandInvokerController extends ActionInvokerController {

        public constructor(
            $scope: ng.IScope,
            private actionService: dg.actions.ActionService,
            private $filter: dgUtils.IFilterService,
            private commandExecutedChannelService: dg.actions.CommandExecutedChannelService
        ) {
            super($scope);
        }

        public command: dg.domain.commands.CommandBase;
        public exclude: Array<string> = [];
        public formEditor: dg.objects.FormEditorController;

        protected getTitle() {
            return this.command.dgMeta.displayName;
        }

        protected getDescription() {
            return this.command.dgMeta.description;
        }

        protected binded() {
            return !!this.command;
        }

        protected executeAction(executionLink: dg.restfulApi.Link) {
            return this.actionService.executeCommand(this.command, executionLink);
        }

        protected executeSucceed(successData) {
            this.commandExecutedChannelService.commandExecuted(this.command);
        }

        protected getInvokeLinks() {
            return this.$filter('dgLinksByRel')(this.command.dgMeta.links,
                dg.restfulApi.DG_LINK_RELS.invoke).filter(l => !l.disabledReason);
        }

        protected init() {
            if (!this.propTemplateUrl) {
                this.propTemplateUrl = '/digmo/src/actions/command/default-prop-template.html';
            }
        }
    }

    angular.module('dg.actions').component('commandInvoker', {
        bindings: {
            command: '<',
            propTemplateUrl: '<?'
        },
        require: {
            formEditor: '^formEditor'
        },
        templateUrl: '/digmo/src/actions/action-invoker.html',
        controller: CommandInvokerController

    });
}